import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import swal from 'sweetalert';
import { Navigate, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'
import { toast } from 'react-toastify';
import shopping from "assets/images/shopping.png";
import Swal from 'sweetalert2';
import Icon from "@mui/material/Icon";



const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

const CartSection = ({ details, showCart, showCards ,setShowPayment,cart,setShowCart,getCartData, paymentToken}) => {
  const [loading, setLoading] = useState(false);

  const [quantities, setQuantities] = useState({});
  const [cartData, setCartData] = useState(cart);
  const [checkoutButton, setCheckoutButton] = useState()
  const [Disable,setDisable]=useState(false)
  const [retailerWalletBalance, setRetailerWalletBalance] = useState(0);

  useEffect(() => {
    const initialQuantities = {};
    cart?.cart_array?.forEach(item => {
      initialQuantities[item?.tap_plan_id] = item?.stock_quantity || 0;
      setCheckoutButton(item?.stock_quantity)
    });
    setQuantities(initialQuantities);
  //  handleGoToCart();
  }, [cart]);

  const handleBack=()=>{
    setShowCart(false)
  }

  const handleUpdateCart = async (planId, newQuantity) => {
    const cartData = {
      retailer_id: sessionStorage.getItem('retailerID'),
      tap_plan_id: planId,
      quantity: newQuantity
    };

console.log('rid',cartData);
    try {
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/add-to-cart`, cartData, { headers: header });
      setCheckoutButton(response.data.data.cart_count_total)
      console.log("response in hndle cart", response.data.data.cart_count_total)
      if(response.data.data.cart_count_total===0){
        setCartData("")
        showCards(false)
        showCart(false)
       }


      handleGoToCart();
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const incrementQty = (planId) => {
    console.log("planId", planId)
    
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty < 30) {
        const newQty = currentQty + 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const decrementQty = (planId) => {
    console.log("planId", planId)

    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = currentQty - 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const removeItem = async (planId) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = 0;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
        tap_plan_id: planId,
        quantity: 0
      };

      console.log("formdata.retailerid" ,formData.retailer_id)
     const response= await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/add-to-cart`, formData, { headers: header });
        if(response.status===200){
               console.log("cart count",response.data.data.cart_count_total)
               if(response.data.data.cart_count_total===0){
                setCartData("")
                showCards(false)
                showCart(false)
               }
        }
       
      handleGoToCart();
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  const handleGoToCart = async () => {
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
      };
      const response = await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/cart`, formData, { headers: header });
      if (response.status === 200) {
        setCartData(response.data?.data);
        setRetailerWalletBalance(response.data?.data?.retailer_wallet_balance);
        getCartData(response.data?.data);
        
        
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  const handleDropDown = async (value, tapPlanId) => {
    setTextareaValues(prevValues => ({ ...prevValues, [tapPlanId]: value }));
    try {
      const header = await getApiHeader();
      const params = new URLSearchParams();
      params.append('plan_id', tapPlanId);
      params.append('control_number', value);
      const response = await axios.get(`${SERVER_URL}sell-physical-recharge-vouchers/search-control-number?${params.toString()}`, {
        headers: header
      });
      if (response.status === 200) {
        setDropDownData(prevData => ({ ...prevData, [tapPlanId]: response.data.data }));
      }
    } catch (error) {
      console.error("Error fetching control numbers:", error);
    }
  };

 

  const suggestionHandler = (tapPlanId, newControlNumber) => {
    console.log("tapPlanId", tapPlanId);
    console.log("suggestion control number", newControlNumber);
    const availableQuantity = quantities[tapPlanId]; // Quantity of the plan for the given tapPlanId
    console.log("Plan's available quantity", availableQuantity);
  
    setControlNumbers(prevControlNumbers => {
      // Count how many times this control number has been added for this plan
      const controlNumberCountForPlan = prevControlNumbers.filter(
        entry => entry.plan_id === tapPlanId
      ).length;
  
      console.log("Current count of control numbers for this plan:", controlNumberCountForPlan);
  
      // Check if adding another entry would exceed the available quantity
      if (controlNumberCountForPlan >= availableQuantity) {
        console.log("Cannot add more control numbers for this plan, limit reached.");
         toast.error("Cannot add more control numbers for this plan, limit reached.")
        return prevControlNumbers; // Do not update the state if limit is reached
      }
  
      // Create a new entry
      const newEntry = {
        plan_id: tapPlanId,
        control_no: newControlNumber
      };
  
      // Check if this entry already exists
      const exists = prevControlNumbers.some(
        entry => entry.plan_id === newEntry.plan_id && entry.control_no === newEntry.control_no
      );
  
      // If it does not exist, add the new entry
      if (!exists) {
        console.log("Adding new control number entry:", newEntry);
        return [...prevControlNumbers, newEntry];
      }
  
      console.log("Entry already exists, not adding.");
       toast.error("Entry alredy exists")
      return prevControlNumbers; // No changes if the entry already exists
    });
  };



  const handleCheckout=async ()=> {
    setShowPayment(true)
    setShowCart(false)
    const header = await getApiHeader();
    const res= await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/checkout`, {},{
      headers: header
    });
console.log('data',res.data.data.payment_system_token);
      if(res.status===200){
        paymentToken(res.data.data.payment_system_token)
       // setShowCart(true,data)
        setLoading(false)
      }
     
  }

  const handleRemoveProduct = async (plan_id) => {
    // const result = await swal({
    //   title: 'Are you sure?',
    //   text: 'Do you want to remove this from your cart?',
    //   icon: 'warning',
    //   buttons: {
    //     confirm: {
    //       text: 'Yes, remove it',
    //       value: true,
    //       visible: true,
    //       className: '',
    //       closeModal: true,
    //     },
    //     cancel: {
    //       text: 'No, cancel!',
    //       value: false,
    //       visible: true,
    //       className: '',
    //       closeModal: true,
          
    //     },
    //   },
    //   dangerMode: true,
    // });
  
    // if (!result) {
    //   // User canceled the action
    //   return;
    // }
  
    // Proceed to remove the item
    removeItem(plan_id);
  };
  





  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}
        
        {cartData?.cart_array?.length > 0 ?   
      <div className="container cart cart-section">
        <h4 style={{fontWeight:'bold'}} className="text-center mb-4">Confirm Order</h4>
        {cartData?.cart_array?.length > 0 ? (
          <div className="oc-table">
          <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Product</th>
                <th>Unit Price</th>
                <th>Qty</th>
                <th>Subtotal</th>
                <th>Discount</th>
                <th>Net Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cartData?.cart_array?.map((item, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>
                      <img
                        src={item.image}
                        // src={"http://retail-api.checkus.info/images/recharge_voucher_queueing/sell_physical_recharge_plan_id_17_image.png"}
                        alt={item?.offerName || "Product"}
                        className="img-fluid"
                        style={{ width: '100px' }}
                      />
                      <p style={{ textAlign: "center", color: "black" }}>{item?.offerName}</p>
                    </td>
                    <td>${item?.amount}</td>
                    {/* <td>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => decrementQty(item?.plan_id) }>-</button>
                      <span className="mx-2">{quantities[item?.tap_plan_id] || item?.stock_quantity || 0}</span>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => incrementQty(item?.plan_id)}>+</button>
                    </td> */}

                    <td>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => decrementQty(item?.tap_plan_id)}
                        // disabled={false}
                      >
                        -
                      </button>

                      <span className="mx-2">{quantities[item?.tap_plan_id] || item?.stock_quantity || 0}</span>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => incrementQty(item?.tap_plan_id)}
                        // disabled={false}
                      >
                        +
                      </button>
                    </td>
                    <td>${item?.sub_total}</td>
                    <td>${item?.discount}</td>
                    <td>${item?.net_total}</td>
                    <td>
                      <button className="btn btn-danger btn-remove" onClick={() => handleRemoveProduct(item?.tap_plan_id)}> Remove <i class="fa fa-times-circle"></i> </button>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div></div>
        ) : (
          <p className="text-center">Your cart is empty.</p>
        )}

        <div className="row mt-4">
          <div className="col-md-6 address-box">
            <h6>Billing & Delivery Address</h6>
            <p style={{fontWeight:"600"}}>{cartData?.address}</p>
            {/* <p>
            Tobeys Paws <br />
            Kochi, Ernakulam, Edapally, Kerala, 123 <br />
            If the address details are incorrect, please contact <br />
            Telsim Retailer Support to change the delivery address <br />
            before confirming the order.
          </p> */}
          <p style={{fontSize:"small"}}> If the address details are incorrect, please contact Telsim Retailer<br></br> Support to change the delivery address before confirming the order.</p>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-end">
              <table className="table">
                <tbody>
                  <tr>
                    <td style={{textAlign: 'left'}}>Subtotal</td>
                    <td style={{textAlign: 'left'}}>: ${cartData?.cart_total?.sub_total}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'left'}}>Discount Applied</td>
                    <td style={{textAlign: 'left'}}>: - ${cartData?.cart_total?.discount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'left'}}>Wallet Credit Used </td>
                    <td style={{textAlign: 'left'}}>: - ${cartData?.cart_total?.wallet_used_amount === 0 ? '0.00' : cartData?.cart_total?.wallet_used_amount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#333'}}>Grand Total</td>
                    <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#c11d6c'}}>: ${cartData?.cart_total?.grand_total}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {checkoutButton > 0 ?
            <div className="d-flex justify-content-end mt-3">
              <button className="checkout checkout-btn" onClick={handleCheckout}>Submit Order <i class="fa fa-caret-right"></i></button>
            </div>
            : ""
          }

        </div>


      </div>
      :
      <div style={{justifyContent:'center',alignItems:'center',textAlign:'center',fontFamily:'-moz-initial'}} className="container cart cart-section">
        <h4 className="text-center mb-4" style={{fontWeight:'bold'}}>Cart is empty</h4>
        <img src={shopping} alt="shopping"  style={{ width: '150px',height:"150px" }} /> 
         {/* <br></br> */}
         <p style={{fontSize:18,textAlign:'center',lineHeight:1.5,color:'black'}}>Must add items on the cart before you proceed to checkout.</p>
      <button style={{margin:"10px", backgroundColor:"#e20e75",borderRadius:"5px" ,border:"none" ,color:"white",padding:"3px",fontSize:"19px",width:"134px",fontWeight:'bolder'}}  onClick={handleBack} >
        {'Go to Plans'}
        <Icon style={{ paddingTop:'2.6%' }}>arrow_forward</Icon>
      </button>
        </div>
}
    </>
  );
};

export default CartSection;
